import React, { useState, useEffect } from "react";
import moment from "moment-timezone";
import { putCaja as modifCaja } from "../helpers/rutaCajas";
import { Modal, Button } from "react-bootstrap";
import 'animate.css';

const ModalFormCaja = ({ caja, handleClose, show }) => {
  const [formValues, setFormValues] = useState({
    codcaj: "",
    fecha: "",
    descripcion: "",
    montoInicial: "",
    saldoActual: "",
  });

  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (caja && caja._id) {
      setFormValues({
        codcaj: caja.codcaj || "",
        fecha: caja.fecha
          ? moment(caja.fecha).format("YYYY-MM-DDTHH:mm")
          : "",
        descripcion: caja.descripcion || "",
        montoInicial: caja.montoInicial || "",
        saldoActual: caja.montoInicial || "", // 👈 sincronizamos por seguridad
      });
    }
  }, [caja]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedValues = {
      ...formValues,
      [name]: value,
    };

    // sincronizamos saldoActual si se cambia montoInicial
    if (name === "montoInicial") {
      updatedValues.saldoActual = value;
    }

    setFormValues(updatedValues);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const cajaModificada = {
      ...formValues,
      saldoActual: formValues.montoInicial,
    };

    try {
      const resp = await modifCaja(caja._id, cajaModificada);
      console.log("✅ Caja actualizada:", resp);

      setShowSuccess(true); // Mostrar modal éxito

      setTimeout(() => {
        setShowSuccess(false); // Ocultar el modal
        handleClose(); // Luego cerrar el modal principal
      }, 2000);
    } catch (err) {
      console.error("❌ Error al guardar:", err);
      // Si querés, podés mostrar un modal de error también
    }
  };


  return (
    <>
    <Modal show={show} onHide={handleClose}>
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Modificar Caja</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="form-group mt-2">
            <label>Fecha</label>
            <input
              type="datetime-local"
              className="form-control"
              name="fecha"
              required
              value={formValues.fecha}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-2">
            <label>Descripción</label>
            <input
              type="text"
              className="form-control"
              name="descripcion"
              required
              value={formValues.descripcion}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-2">
            <label>Monto Inicial</label>
            <input
              type="number"
              className="form-control"
              name="montoInicial"
              required
              value={formValues.montoInicial}
              onChange={handleChange}
              disabled
            />
          </div>

          <div className="form-group mt-2">
            <label>Saldo Actual</label>
            <input
              type="number"
              className="form-control"
              name="saldoActual"
              value={formValues.saldoActual}
              readOnly // 👈 campo solo lectura
            />
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button type="submit" variant="dark">
            Guardar
          </Button>
        </Modal.Footer>
      </form>
    </Modal>

    <Modal
      show={showSuccess}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="animate__animated animate__fadeInDown"
    >
      <Modal.Body className="text-center">
        <div style={{ fontSize: "3rem" }}>🖐</div>
        <h5 className="mt-2">¡Cambios guardados correctamente!</h5>
      </Modal.Body>
    </Modal>
    </>
  );
};

export default ModalFormCaja;
